import Navbar from "../Components/Navbar";
import ContactFooter from "../Components/ContactFooter";
import {useState} from "react";
import {useFormValidation} from "../Validation/UseFormValidation";
import {ContactFormScheme} from "../Validation/FormSchemes/ContactFormScheme";
import {ErrorMessage} from "../Components/ErrorMessage";

export function Contact() {
  const [formData, setFormData] = useState({
    email: "",
    phone: "",
    firstName: "",
    lastName: "",
    message: "",
    honeyPot: ""
  });

  const {errors, validateForm, resetErrors} = useFormValidation(ContactFormScheme);
  const [confirmation, setConfirmation] = useState("");

  const handleChange = (e: { target: { name: any; value: any; }; }) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const characterCount = formData.message.length;

  const handleSubmit = async (e: { preventDefault: () => void; }) => {
    e.preventDefault();

    setConfirmation("");

    if (!validateForm(formData)) return;
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/Mail/CustomerMessage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error("Failed to send message");
      }

      console.log("Message sent!");
      setConfirmation("Bericht is verstuurd!")

      resetErrors();

      // clearing the form
      setFormData(prev => {
        const clearedData = {...prev};

        Object.keys(clearedData).forEach((key) => {
          clearedData[key as keyof typeof clearedData] = "";
        });

        return clearedData;
      });

    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Navbar/>

      <div className="white-text-block white-text-block--center">
        <h1 className="header-1">Contact</h1>
        <p>Bij speciale verzoeken, grote bestellingen of high teas kunt u een eigen bericht sturen.
          Voer hier zo veel mogelijk relevante informatie in zodat u zo goed mogelijk geholpen kunt worden.
          Denk aan datums waarop u een taart zou willen hebben,
          de hoeveelheden en variaties die u in een grote bestelling zou willen hebben,
          of het benoemen van eventuele allergieen. 
          Speciale verzoeken moeten minstens een week van te voren worden ingedient.
        </p>
      </div>

      <div className="white-text-block white-text-block--center">
        <form onSubmit={handleSubmit}>
          <input className="anti-bot-field" type="text" name="honeyPot"
                 value={formData.honeyPot} onChange={handleChange}/>

          <ul className="horizontal-form">
            <li className="form-item">
              <h3 className="input-label">E-mail</h3>
              <input className="input-field input-field--long" type="text" name="email"
                     value={formData.email} onChange={handleChange}/>
              <ErrorMessage error={errors.email}/>
            </li>
            <li className="form-item">
              <h3 className="input-label">Telefoon nummer</h3>
              <input className="input-field" type="text" name="phone"
                     value={formData.phone} onChange={handleChange}/>
              <ErrorMessage error={errors.phone}/>
            </li>
          </ul>

          <ul className="horizontal-form">
            <li className="form-item">
              <h3 className="input-label">Voornaam</h3>
              <input className="input-field" type="text" name="firstName"
                     value={formData.firstName} onChange={handleChange}/>
              <ErrorMessage error={errors.firstName}/>
            </li>
            <li className="form-item">
              <h3 className="input-label">Achternaam</h3>
              <input className="input-field" type="text" name="lastName"
                     value={formData.lastName} onChange={handleChange}/>
              <ErrorMessage error={errors.lastName}/>
            </li>
          </ul>

          <div className="form-item">
            <ul className="text-area-labels">
              <li>
                <h3 className="input-label">Bericht</h3>
              </li>
              <li className="character-count">
                <h3>{characterCount}/500</h3>
              </li>
            </ul>
            <textarea className="text-area" name="message"
                      value={formData.message} onChange={handleChange}/>
            <ErrorMessage error={errors.message}/>
          </div>

          <button className="button" type="submit">Stuur bericht</button>
          <p className="form-confirmation">
            {confirmation}
          </p>
        </form>
      </div>

      <ContactFooter/>
    </>
  );
}

export default Contact;